module.exports = __webpack_public_path__ + "img/SWP_Staff_2H_02 (1).b4ddbf7f.png";